import Sidenav from "../../components/navs/Sidenav";
import Topnav from "../../components/navs/Topnav";

import { Outlet } from "react-router-dom";
import { useCallback, useEffect, useRef } from "react";
import startLogoutTimer from "../../utils/startLogoutTimer";
import { resetStaffRecords } from "../../redux/slice/staff/staffSlice";
import { resetOffices } from "../../redux/slice/office/officeSlice";
import { resetPolicy } from "../../redux/slice/policy/policySlice";
import { resetPolicy as resetSavingsPolicy } from "../../redux/slice/policy/savingsPolicy/savingsPolicySlice";
import { resetAuth } from "../../redux/slice/auth/authSlice";
import { resetUsers } from "../../redux/slice/user/userSlice";
import { resetCustomers } from "../../redux/slice/customer/customerSlice";
import { resetChartOfAccountState } from "../../redux/slice/accounting/accountingSlice";
import { resetRolesStatus } from "../../redux/slice/roles/roleSlice";
import { resetCommission } from "../../redux/slice/commission/commissionSlice";
import { resetDash } from "../../redux/slice/dash/dashSlice";
import { useDispatch, useSelector } from "react-redux";
import { flashMessage as flash } from "../../utils/flash";
import { resetWorkflow } from "../../redux/slice/workflow/workflowSlice";
import { resetLifeCover } from "../../redux/slice/lifecover/lifecoverSlice";

const logout = () => {
  // Perform logout actions
  // e.g., clear authentication tokens, redirect to login page, etc.
};
const Main = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { user: user_info } = user;

  const logout = useRef(() => {
    flash("info", "Logged out, There was no activity going on");
    dispatch(resetStaffRecords());
    dispatch(resetOffices());
    dispatch(resetPolicy());
    dispatch(resetAuth());
    dispatch(resetUsers());
    dispatch(resetCustomers());
    dispatch(resetChartOfAccountState());
    dispatch(resetRolesStatus());
    dispatch(resetCommission());
    dispatch(resetWorkflow());
    dispatch(resetDash());
    dispatch(resetSavingsPolicy())
    dispatch(logout(user_info.id));
  });

  const inactivityDuration = 300000; // Specify the inactivity duration (e.g., 5 minutes = 300000 milliseconds)

  // useEffect(() => {
  //   const cleanup = startLogoutTimer(logout.current, inactivityDuration);
  //   return cleanup;
  // }, [inactivityDuration]);

  return (
    <div className='wrapper'>
      {/* sidenav */}
      <Sidenav />
      {/* end sidenav */}

      {/* content */}
      <div className='content-page'>
        <div className='content'>
          {/* topnav */}
          <Topnav />
          {/* end topnav */}

          {/* <!-- Start Content--> */}
          <div className='container-fluid'>
            <div className='main-content'>
              <Outlet />
            </div>
          </div>
          {/* container */}
        </div>
        {/* content */}

        {/* Footer Start */}
        <footer className='footer'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-md-6'>
                {new Date().getFullYear()} &copy; Powered by InsureTech.
                {/* <a href="http://prudentchoice.com.ng/" target='_blank'> prudentchoice.com.ng</a> */}
              </div>
              <div className='col-md-6'>
                <div className='text-md-end footer-links d-none d-md-block'>
                  <a href='/'>About</a>
                  <a href='/'>Support</a>
                  <a href='/'>Contact Us</a>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* end Footer */}
      </div>
      {/* end content */}
    </div>
  );
};

export default Main;
